module.exports = __webpack_public_path__ + "img/Patent_7.f198856d.jpg";